module.exports = __webpack_public_path__ + "img/K.064832ff.png";